export default "__VITE_ASSET__DLDFLCFf__"